// AnalyticsHomePage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Row,
  Col,
  PreviewAltCard,
} from "../../components/Component";
import { Card } from "reactstrap";
import SendingSpendingChart from "./SendingSpendingChart";
import SubscriptionsCard from "./SubscriptionsCard";

const AnalyticsHomePage = () => {
  const [sentMessagesByInterval, setSentMessagesByInterval] = useState([]);
  const [receivedMessagesByInterval, setReceivedMessagesByInterval] = useState([]);
  const [interval, setInterval] = useState("month");
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const navigate = useNavigate();
  const token = Cookies.get('token');

  const fetchSentMessages = async () => {
    const url = `${global.SERVIP}/analytics/get_messages_by_interval`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ interval }),
      });

      const data = await response.json();
      if (data.ok) {
        setSentMessagesByInterval(data.messages);
      } else {
        console.error("Sent messages error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching sent messages:", error);
    }
  };

  const fetchReceivedMessages = async () => {
    const url = `${global.SERVIP}/analytics/get_received_messages_by_interval`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ interval }),
      });

      const data = await response.json();
      if (data.ok) {
        setReceivedMessagesByInterval(data.messages);
      } else {
        console.error("Received messages error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching received messages:", error);
    }
  };

  const fetchSubscriptions = async () => {
    const url = `${global.SERVIP}/user/get_subscriptions`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setUserSubscriptions(data.subscriptions);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSentMessages();
      fetchReceivedMessages();
      fetchSubscriptions();
    }
  }, [interval]);

  return (
    <>
      <Head title="Balance and Overview" />
      <Content>
        <BlockHead size="sm">
          <div className="nk-block-between">
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Analytics
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>Get insights into your messaging activity and subscriptions.</p>
              </BlockDes>
            </BlockHeadContent>
          </div>
        </BlockHead>

        <Block>
          <Row className="g-gs flex-column">
            <Col xs="12" className="mb-4">
              <PreviewAltCard className="w-100">
                <SendingSpendingChart
                  sentMessages={sentMessagesByInterval}
                  receivedMessages={receivedMessagesByInterval}
                  interval={interval}
                  setInterval={setInterval}
                />
              </PreviewAltCard>
            </Col>

            <Col xs="12">
              <Card className="card-bordered w-100">
                <SubscriptionsCard subscriptions={userSubscriptions} />
              </Card>
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default AnalyticsHomePage;
